import { WfWorkplace } from 'src/api/wf/models/WfWorkplace';
import { getOperationStatusTranslationKey } from 'src/api/wf/models/enums/WfOperationtStatus';
import P_CollapsibleSection from '../common/collapsibleSection/P_CollapsibleSection';
import { useTranslation } from 'react-i18next';
import { FormRow } from '../../common/form/FormRow';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';

type WideAreaDisasterSectionProps = {
  workplace: WfWorkplace | null;
};

const toDisplayText = (value?: string | null) => {
  if (value === null || value === undefined) return '';

  const trimmed = value.trim();
  if (trimmed === '' || trimmed === 'null') return '';

  return trimmed;
};

export function WideAreaDisasterSection({ workplace }: WideAreaDisasterSectionProps) {
  const { t } = useTranslation();
  const details = workplace?.details;

  return (
    <P_CollapsibleSection
      title={t('wf.siteDetails.wideAreaDisasterInfo')}
      contentClassName={`grid grid-flow-row text-left ${useUserAgent().isDesktop ? '' : 'space-y-4'}`}
    >
      <FormRow title={t('wf.common.status')}>
        <div>{details?.statusId ? t(getOperationStatusTranslationKey(details.statusId)) : ''}</div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.onCall')}>
        <div>{details?.onCall ?? ''}</div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.alert')}>
        <div>{details?.alert ?? ''}</div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.confinement')}>
        <div>{details?.confinement ?? ''}</div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.powerOutage')}>
        <div>{details?.powerOutage ?? ''}</div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.floodRequired')}>
        <div>
          {details?.floodRequired
            ? t('wf.propertyList.details.floodResponseRequiredTrue')
            : t('wf.propertyList.details.floodResponseRequiredFalse')}
        </div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.partsRequired')}>
        <div>
          {details?.partsRequired
            ? t('wf.propertyList.details.partsRequiredTrue')
            : t('wf.propertyList.details.partsRequiredFalse')}
        </div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.submitted')}>
        <div>
          {details?.submitted === true
            ? t('wf.propertyList.details.submittedTrue')
            : details?.submitted === false
              ? t('wf.propertyList.details.submittedFalse')
              : ''}
        </div>
      </FormRow>

      <FormRow title={t('wf.siteDetails.dispatchedWorker')}>
        <div>{toDisplayText(details?.reservations?.[0]?.engineerName)}</div>
      </FormRow>
    </P_CollapsibleSection>
  );
}
